export const GUIDED_TOUR_SWITCH_KEY = "enable_guided_tour";

const BRANDS_WITHOUT_TOUR_BY_DEFAULT = new Set(["flow"]);

export function guidedTourDefault(brandId: string): boolean {
  return !BRANDS_WITHOUT_TOUR_BY_DEFAULT.has(brandId);
}

export function isGuidedTourOn(brandId: string, value: string | null | undefined): boolean {
  if (typeof value !== "string" || value.trim() === "") return guidedTourDefault(brandId);
  return value.trim().toLowerCase() === "true";
}
